import api from "../api";
import Cookies from "js-cookie";
import { otp_endpoint,user_endpoint,review,store_endpoint,shop_endpoint,enquiry_endpoint,profile,cart, medical_text, medical_test} from '../api_endpoints'
import { toast } from "react-toastify";
const { SendOtp_API,VerifyOtp_API} = otp_endpoint;
const{OutlateFetch_API}=store_endpoint
const {fetchCategories_API,fetchSubcategories_API,fetchProductsBySubcatagories_API,fetchProducts_API}=shop_endpoint
const {UserCreate_API} = user_endpoint;
const {reviewQuestionGet,reviewAnswer} = review;
const {Enquiry_API,Create_partnership_API,Product_Enquiry_API}=enquiry_endpoint
const {getProfile_API,getWishlist_API,orderHistory_API,editProfile} = profile;
const {addToCart_API,increament_API,decreament_API,viewCart_API,removeItem_API,clearCart_API,checkout_API,rozarpay_order_API,razorpay_success_API,service_add_API} = cart;

export const sendOtpApi = async (phone) => {
  try {
    const response = await api.post(SendOtp_API, { phone });
    return response.data;
  } catch (error) {
    console.log("SEND_OTP_API_ERROR..........", error);
    throw error;
  }
};

export const VerifyOtpApi = async (phone, otp) => {
  try {
    const response = await api.post(VerifyOtp_API, { primaryNumber:phone, otp });
    return response.data;
  } catch (error) {
    console.log("VERIFY_OTP_API_ERROR..........", error);
    throw error;
  }
};

export const fetchingOutlate=async()=>{

  try {
    const response=await api.get(OutlateFetch_API)
    console.log(response);
    
    return response.data
  } catch (error) {
    throw error
  }
}
export const fetchProductCategories=async()=>{

  try {
    const response=await api.get(fetchCategories_API)
    return response.data
  } catch (error) {
    throw error
  }
}
export const fetchSubcategoriesByCategory=async(category)=>{
  try {
    const response=await api.get(`${fetchSubcategories_API}/${category}`)
    console.log(response);
    
    return response.data
  } catch (error) {
    throw error
  }
}

export const fetchProductsBySubcategory=async(scid)=>{
  try {
    const response=await api.get(`${fetchProductsBySubcatagories_API}/${scid}`)
    console.log(response);
    
    return response.data
  } catch (error) {
    throw error
  }
}


export const UserCreateAPI = async (data) => {
  try {
    const response = await api.post(UserCreate_API,data);
    return response;
  } catch (error) {
    console.log("VERIFY_OTP_API_ERROR..........", error);
    throw error;
  }
};

export const getreviewQuestionApi = async () => {
  let result = [];
   
  try {
    const response = await api.get(reviewQuestionGet);

    console.log("Response:", response);
    result = response.data;
    return result;
  } catch (error) {
    console.error("Network Error:", error.message);
    throw error;
  }
  
};

export const submitReview = async (data) => {
   if(!Cookies.get('loginData')){
                
                toast.error("Unauthorized,Login first")
                return
              }
  try {
    const response = await api.post(reviewAnswer,data,{
      "headers": {
        'Authorization': `Bearer ${JSON.parse(Cookies.get('loginData'))}`
      }
    });
    return response.data;
  } catch (error) {
    console.log("VERIFY_OTP_API_ERROR..........", error);
    throw error;
  }
};

export const createJobEnquiry = async (data) => {
   if(!Cookies.get('loginData')){
              
                toast.error("Unauthorized,Login first")
                return
              }
  try {

    // const signupData = JSON.parse(localStorage.getItem("signupdata"));
    const token = JSON.parse(Cookies.get('loginData'))
    const response=await api.post(Enquiry_API, data,{
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}` 
      }
    });
    console.log("Enquiry API Response:", response);
    return response;
  } catch (error) {
    console.log("Enquiry_API_ERROR..........", error);
    throw error;
    
  }
}

export const createProductEnquiry = async (data) => {
   if(!Cookies.get('loginData')){
                
                toast.error("Unauthorized,Login first")
                return
              }
  try {

    // const signupData = JSON.parse(localStorage.getItem("signupdata"));
    const token = JSON.parse(Cookies.get('loginData'))
    const response=await api.post(Product_Enquiry_API, data,{
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}` 
      }
    });
    console.log("Enquiry API Response:", response);
    return response;
  } catch (error) {
    console.log("Enquiry_API_ERROR..........", error);
    throw error;
    
  }
}


export const createPartnerShip = async (data) => {
   if(!Cookies.get('loginData')){
                
                toast.error("Unauthorized,Login first")
                return
              }
  try {

    // const signupData = JSON.parse(localStorage.getItem("signupdata"));
    const token = JSON.parse(Cookies.get('loginData'))
    const response=await api.post(Create_partnership_API, data,{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      }
    });
    console.log("Enquiry API Response:", response);
    return response;
  } catch (error) {
    console.log("Enquiry_API_ERROR..........", error);
    throw error;
    
  }
}

export const getProfile = async ()=>{
   if(!Cookies.get('loginData')){
                
                toast.error("Unauthorized,Login first")
                return
              }
  try {
     const token = JSON.parse(Cookies.get('loginData'))

   const response= await api.get(getProfile_API,
     {headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      }}
   )
   return response
    
  } catch (error) {
    throw error;
  }
}
export const getWishlist = async ()=>{
   if(!Cookies.get('loginData')){
                
                toast.error("Unauthorized,Login first")
                return
              }
  try {
     const token = JSON.parse(Cookies.get('loginData'))

   const response= await api.get(getWishlist_API,
     {headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      }}
   )
   return response
    
  } catch (error) {
    throw error;
  }
}

export const addWishlist=async(productId)=>{
  try {
     const token = JSON.parse(Cookies.get('loginData'))

    const response=await api.post(cart.addWishlist,productId,
      {headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      }})
      return response
  } catch (error) {
   throw error
    
  }
}

export const sendQuerySupport=async(data)=>{
  try {
     const token = JSON.parse(Cookies.get('loginData'))

    const response=await api.post(cart.sendSupportQuery,data,
      {headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      }})
      return response
  } catch (error) {
   throw error
    
  }
}


export const getQuerySupport=async()=>{
  try {
     const token = JSON.parse(Cookies.get('loginData'))

    const response=await api.get(cart.getSupportQuery,
      {headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      }})
      return response
  } catch (error) {
   throw error
    
  }
}
export const getCustomizedBooking = async ()=>{
   if(!Cookies.get('loginData')){
                
                toast.error("Unauthorized,Login first")
                return
              }
  try {
     const token = JSON.parse(Cookies.get('loginData'))

   const response= await api.get(profile.getCustomized_API,
     {headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      }}
   )
   console.log("token",token);
   
   return response
    
  } catch (error) {
    throw error;
  }
}

export const getOrderHistory = async ()=>{
   if(!Cookies.get('loginData')){
                
                toast.error("Unauthorized,Login first")
                return
              }
  try {
     const token = JSON.parse(Cookies.get('loginData'))

   const response= await api.get(orderHistory_API,
     {headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      }}
   )
   return response
    
  } catch (error) {
    throw error;
  }
}
export const getServiceHistory = async ()=>{
   if(!Cookies.get('loginData')){
                
                toast.error("Unauthorized,Login first")
                return
              }
  try {
     const token = JSON.parse(Cookies.get('loginData'))

   const response= await api.get(profile.serviceHistory,
     {headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      }}
   )
   return response
    
  } catch (error) {
    throw error;
  }
}

export const getInvoice = async (id)=>{
   if(!Cookies.get('loginData')){
                
                toast.error("Unauthorized,Login first")
                return
              }
  try {
     const token = JSON.parse(Cookies.get('loginData'))

   const response= await api.get(`${profile.cartInvoice}${id}`,
     {headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      }}
   )
   return response
    
  } catch (error) {
    throw error;
  }
}
export const getProducts = async ()=>{
  try {
    //  const token = JSON.parse(Cookies.get('loginData'))
    // accessable for unauthorized user

   const response= await api.get(fetchProducts_API,
     {headers: {
        'Content-Type': 'application/json',
         
      }}
   )
   return response
    
  } catch (error) {
    throw error;
  }
}

export const addToCart = async (data) => {
   if(!Cookies.get('loginData')){
                
                toast.error("Unauthorized,Login first")
                return
              }
  try {
    const token = JSON.parse(Cookies.get('loginData'))
    const response = await api.post(addToCart_API, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
   
    console.log("Add to Cart Response:", response);
     return response;
    
  } catch (error) {
    throw error;
  }
}

export const increamentCart = async (productId) => {
   if(!Cookies.get('loginData')){
                
                toast.error("Unauthorized,Login first")
                return
              }
  try {
    console.log(productId);
     const token = JSON.parse(Cookies.get('loginData'))
    
    const  response=await api.put(`${increament_API}/${productId}`,{},{
      headers:{ 
        'Content-Type': 'application/json', 
        'Authorization': `Bearer ${token}`
      }
      
    } )

    console.log("Increment Cart Response:", response);
    return response.data;
    
  } catch (error) {
    console.log("Error in increamentCart:", error);
    throw error;
  }
}

export const decreamentCart = async (productId) => {
   if(!Cookies.get('loginData')){
              
                toast.error("Unauthorized,Login first")
                return
              }
  try {
    const  response=await api.put(`${decreament_API}/${productId}`,{},{
      headers:{
        
        'Authorization': `Bearer ${JSON.parse(Cookies.get('loginData'))}`
      }
      
    } )

    console.log("Decrement Cart Response:", response);
    return response.data;
    
  } catch (error) {
    console.log("Error in decreamentCart:", error);
    throw error;
  }
}

export const ViewCartItems = async () => {
  try {
    const  response=await api.get(viewCart_API,{
      headers:{ 
        'Authorization': `Bearer ${JSON.parse(Cookies.get('loginData'))}`
      }
      
    } )

    console.log("cart fetch:", response);
    return response.data;
    
  } catch (error) {
    console.log("Error in cart fetching:", error);
    throw error;
  }
}

export const removeItemFromCart= async (productId) => {
   if(!Cookies.get('loginData')){
                
                toast.error("Unauthorized,Login first")
                return
              }
  try {
    const  response=await api.delete(`${removeItem_API}/${productId}`,{
      headers:{
        
        'Authorization': `Bearer ${JSON.parse(Cookies.get('loginData'))}`
      }
      
    } )

    console.log("remove Cart Response:", response);
    return response.data;
    
  } catch (error) {
    console.log("Error in remove Cart:", error);
    throw error;
  }
}
export const clearItemFromCart= async () => {  // clear all items from cart
   if(!Cookies.get('loginData')){
        
                toast.error("Unauthorized,Login first")
                return
              }
  try {
    const  response=await api.delete(`${clearCart_API}`,{
      headers:{
        
        'Authorization': `Bearer ${JSON.parse(Cookies.get('loginData'))}`
      }
      
    } )

    console.log("remove Cart Response:", response);
    return response.data;
    
  } catch (error) {
    console.log("Error in remove Cart:", error);
    throw error;
  }
}

export const checkOut = async (data) => {
   if(!Cookies.get('loginData')){
              
                toast.error("Unauthorized,Login first")
                return
              }
  try {
    const token = JSON.parse(Cookies.get('loginData'))
    const response = await api.post(checkout_API, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
   
    console.log("Check out Response:", response);
     return response;
    
  } catch (error) {
    throw error;
  }
}

export const orderRazorpay=async(data)=>{
   if(!Cookies.get('loginData')){
            
                toast.error("Unauthorized,Login first")
                return
              }
   const token = JSON.parse(Cookies.get('loginData'))
  try {
    const response=await api.post(rozarpay_order_API,
      { amount: data.amount, // 5.00 INR in paisa
        currency: 'INR'},{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
   
    

    return response
    
  } catch (error) {
   
    
    throw error
  }
}

export const successRazorpay=async(data)=>{
   if(!Cookies.get('loginData')){
                
                toast.error("Unauthorized,Login first")
                return
              }
  const token = JSON.parse(Cookies.get('loginData'))
  try {
    const response= await api.post(razorpay_success_API,{
        razorpayOrderId: data.razorpayOrderId,
  razorpayPaymentId: data.razorpayPaymentId,
  razorpaySignature: data.razorpaySignature
    },{
       headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
    return response
    
  } catch (error) {
    throw error
  }
}

export const serviceAdd=async(data)=>{
   if(!Cookies.get('loginData')){
          
                toast.error("Unauthorized,Login first")
                return
              }
              
   const token = JSON.parse(Cookies.get('loginData'))
  try {
    console.log("input data",data);
    
    const response=await api.post(service_add_API,data,
      {
       headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`}
    }
    )

    return response;
  } catch (error) {
    throw error
  }
}


export const editProfileApi=async(data)=>{
    const token = JSON.parse(Cookies.get('loginData'))
  try {
    const response=await api.put(editProfile,data,{
            headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`}

    })
    return response
    
  } catch (error) {
    throw error
  }

}

export const customizeBooking = async (data) => {
   if(!Cookies.get('loginData')){
              
                toast.error("Unauthorized,Login first")
                return
              }
  try {
    const token = JSON.parse(Cookies.get('loginData'))
    const response = await api.post(cart.customizeBooking_api, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
   
    console.log("customize booking Response:", response);
     return response;
    
  } catch (error) {
    throw error;
  }
}

export const sendSupportMessage=async(data)=>{
  try {
     const token = JSON.parse(Cookies.get('loginData'))
    const response = await api.post(profile.sendSupportMessage, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const replySupportMessage=async(data)=>{
  try {
     const token = JSON.parse(Cookies.get('loginData'))
    const response = await api.post(profile.replySupportMessage, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const getSupportMessage=async(data)=>{
  try {
     const token = JSON.parse(Cookies.get('loginData'))
    const response = await api.get(`${profile.getSupportMessages}${data}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const mySupportMessage=async()=>{
  try {
     const token = JSON.parse(Cookies.get('loginData'))
    const response = await api.get(`${profile.mySupportsMessages}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const getMedicalTests=async()=>{
  try {
     const token = JSON.parse(Cookies.get('loginData'))
    const response = await api.get(medical_test.getAllService, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const calculateMedicalTestsBill=async(data)=>{
  try {
     const token = JSON.parse(Cookies.get('loginData'))
    const response = await api.post(medical_test.billCalculation,data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const orderMedicalTests=async(data)=>{
  try {
     const token = JSON.parse(Cookies.get('loginData'))
     console.log(token);
     
    const response = await api.post(`${medical_test.medicalTestOrder}${data}`, {
      headers: {
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}



export const assignPatient=async(data)=>{
  try {
   
    data.forEach((value, key) => {
  console.log(`${key}:`, value);
});
    
    // const token = JSON.parse(Cookies.get('loginData'))
    const response = await api.post(user_endpoint.patientassign,data, {
      headers: {
        //'Content-Type': 'application/json',
         'Content-Type': 'multipart/form-data',
        },
      
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}


export const getCustomizeTestReport=async(data)=>{
  try {
     const token = JSON.parse(Cookies.get('loginData'))
    const response = await api.get(`${profile.customizeTestReport}${data}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}